import StaffCard from './staff-card';

module.exports = StaffCard;



// WEBPACK FOOTER //
// ./src/staff-card-bundle.js